export default "__VITE_ASSET__6ykZ27CJ__"